import React, { useState, useRef } from 'react';
import {
  Box, Button, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText,
  Divider, Typography, Menu, MenuItem, Collapse, Paper, Grow, Popper
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import TranslateIcon from '@mui/icons-material/Translate';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import logo from '../../images/kar_main_logo.png';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ChevronRight from '@mui/icons-material/ChevronRight';
import {MainSearchBar} from '../searchHook/searchComponent';
import leftImage from '../../images/chief_minister_of_karrnat.png';
import rightImage from '../../images/rev minister.jpeg';
import leftImageEnglish from '../../images/leftImageEnglish.png';
import rightImageEnglish from '../../images/rightImageEnglish.jpg';
export const NavBar = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useSelector((state) => state.auth);

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'kn', label: 'Kannada' }
  ];

  // Language-based image selection
const getLanguageImages = () => {
  const lang = i18n.language || 'en';
  
  return {
    leftImage: lang === 'kn' ? leftImage : leftImageEnglish,
    rightImage: lang === 'kn' ? rightImage : rightImageEnglish,
  };
};

const images = getLanguageImages();

  // Define nested menu structure
  const menuItems = [
    { name: t('home'), to: '/' },
    {
      name: t('about.title'),
      submenu: [
        {
          name: t('about.introduction.title'),
          submenu: [
            { name: t('about.introduction.sploca'), to: '/introduction/sploca' },
            { name: t('about.introduction.orgchart'), to: '/org-chart' },
            { name: t('legalFramework.legalTeam'), to: '/legal/law/legal-team'},
          ]
        },
        {
          name: t('about.competentAuthority.title'),
          // submenu: [
            // {
            //   name: t('about.competentAuthority.authority.title'),
              submenu: [
                { name: t('about.competentAuthority.authority.govtOrder'), to: '/ca/authority/govtorders' },
                { name: t('about.competentAuthority.authority.assignedFinancialEstablishment'), to: '/ca/authority/assingnedfe' }
            //   ]
            // }
          ]
        },
        { name: t('about.calendarOfEvent'), to: '/about/calenderEvent' }
      ]
    },
    { name: t('financialEstablishment'), to: '/properties' },
    {
      name: t('contact.title'),
      submenu: [
        { name: t('contact.departmentHeadOffice'), to: '/contact/departmentcontacts' },
        { name: t('contact.feedbackForm'), to: '/claim-mgmt' }
      ]
    },
    { 

      name: t('legalFramework.title'),
      submenu: [

        // { name: t('legalFramework.legalTeam'), to: '/legal/law/legal-team'},

        {
          name: t('legalFramework.dailyCaseReport.title'),
          submenu: [
            { name: t('legalFramework.dailyCaseReport.specialCourtCases'), to: '/legal/court-cases/daily-report' },
            { name: t('legalFramework.dailyCaseReport.highCourtCases'), to: "/daily-high-court-cases" },
            { name: t('legalFramework.dailyCaseReport.supremeCourtCases'), to: '/daily-supreme-court-cases' }
          ]
        },

        {
          name: t('legalFramework.lawsAndRules.title'),
          submenu: [
            { name: t('legalFramework.lawsAndRules.kpidfeAct'), to: '/legal/law/kpid-act' },
            { name: t('legalFramework.lawsAndRules.budsAct'), to: '/legal/law/buds-act' },
            { name: t('legalFramework.lawsAndRules.otherStatepidfe'), to: '/other-state-pidfe'},
            { name: t('legalFramework.lawsAndRules.otherReleventActs'), to: '/other-relevent-acts'},
            { name: t('legalFramework.lawsAndRules.comparisnOfActs'), to: '/comparisn-of-acts'}
          ]
        },
        {
          name: t('legalFramework.courtCases.title'),
          submenu: [
            // { name: t('legalFramework.courtCases.checkCaseStatus'), to: 'https://services.ecourts.gov.in/ecourtindia_v6/'},
            // { name: t('legalFramework.courtCases.sop'), to: '/sop' },
            { name: t('legalFramework.courtCases.specialCourtOrders'), to: '/legal/court-cases/key-judgements' },
            { name: t('legalFramework.courtCases.highCourtOrder'), to: '/high-court-orders' },
            { name: t('legalFramework.courtCases.SupremeCourtOrders'), to: '/supreme-court-orders' },
            { name: t('legalFramework.courtCases.otherStateCourtOrders'), to: '/other-state-court-orders' },
            
            { name: t('legalFramework.courtCases.legalOpinions'), to: '/legal-opinion' },
            { name: t('legalFramework.courtCases.legalResearch'), to: '/legal-research' },
            // {
            //   name: t('legalFramework.courtCases.legalAdviceBlog.title'),
            //   submenu: [
            //     { name: t('legalFramework.courtCases.legalAdviceBlog.admin'), to: '/legal/court-cases/legal-advice/admin' },
            //     { name: t('legalFramework.courtCases.legalAdviceBlog.register'), to: '/legal/court-cases/legal-advice/register' }
            //   ]
            // }
          ]
        },
        // { name: t('legalFramework.referanceTemplates'), to: '/legal-template'},


        {
          name: t('legalFramework.legaldvise.title'),
          submenu: [
            { name: t('legalFramework.legaldvise.faqs'), to: '/faq' },
            { name: t('legalFramework.legaldvise.legalQueries'), to: '/legal-blogs' },
            { name: t('legalFramework.legaldvise.scamNews'), to: '/scam-news'},
            { name: t('legalFramework.legaldvise.manuals'), to: '/notification/public-notices/ice/manuals-videos'},
          ]
        },


      ]
    },
    {
      name: t('notification.title'),
      submenu: [
        { name: t('notification.circularAndNotification'), to: '/notification/circulars' },
        // {
        //   name: t('notification.splocaCircular.title'),
        //   submenu: [
        //     { name: t('notification.splocaCircular.officeOrders'), to: '/notification/sploca-circular/office-orders' }
        //   ]
        // },
        {
          name: t('notification.rcExOffice.title'),
          submenu: [
            { name: t('notification.rcExOffice.reviewsAndMeetings'), to: '/notification/rc-ex-office/reviews-meetings' }
          ]
        },
        {
          name: t('notification.publicNotices.title'),
          submenu: [
            {
              name: t('notification.publicNotices.publicNotification.title'),
              submenu: [
                { name: t('notification.publicNotices.publicNotification.tender'), to: '/notification/public-notices/tender' },
                { name: t('notification.publicNotices.publicNotification.auction'), to: '/notification/public-notices/auction' },
                { name: t('notification.publicNotices.publicNotification.adv'), to: '/notification/public-notices/adv' }
              ]
            },
            {
              name: t('notification.publicNotices.publicsNotices.title'),
              submenu: [
                { name: t('notification.publicNotices.publicsNotices.summons'), to: '/notification/public-notices/summons' },
                { name: t('notification.publicNotices.publicsNotices.warrants'), to: '/notification/public-notices/warrants' },
                { name: t('notification.publicNotices.publicsNotices.notices'), to: '/notification/public-notices/notices' }
              ]
            },
            {
              name: t('notification.publicNotices.ice.title'),
              submenu: [
                { name: t('notification.publicNotices.ice.infoToDepositors'), to: '/notification/public-notices/ice/info-to-depositors' },
                { name: t('notification.publicNotices.ice.manualsVideos'), to: '/notification/public-notices/ice/manuals-videos' },
                { name: t('notification.publicNotices.ice.notices'), to: '/notification/public-notices/ice/notices' }
              ]
            },
            // { name: t('notification.publicNotices.grievanceSuggestions'), to: '/notification/public-notices/grievance-suggestions' }
          ]
        }
      ]
    },
    {
      name: t('quickLinks.title'),
      submenu: [
         {name: t('quickLinks.revenueDept'), to: 'https://www.rdservices.karnataka.gov.in/', target: '_blank' },
        { name: t('quickLinks.revenueDeptKarnatakaPolice'), to: 'https://ksp.karnataka.gov.in/english', target: '_blank' },
        { name: t('quickLinks.iepfAuthority'), to: 'https://www.iepf.gov.in/' , target: '_blank'},
        { name: t('quickLinks.sfio'), to: 'https://sfio.gov.in/en/', target: '_blank' },
        { name: t('quickLinks.regionalCommissioner'), to: 'https://rcbengaluru.kar.nic.in/' , target: '_blank'},
        { name: t('quickLinks.erajya'), to: 'https://erajyapatra.karnataka.gov.in/' , target: '_blank'},
        { name: t('quickLinks.deptParliamentary'), to: 'https://dpal.karnataka.gov.in/en', target: '_blank'},
        { name: t('quickLinks.highCourt'), to: 'https://judiciary.karnataka.gov.in/', target: '_blank'},
        { name: t('quickLinks.supremeCourt'), to: 'https://www.sci.gov.in/', target: '_blank'}
      ]
    },
    {
      name: t('rti.title'),
      submenu: [
        { name: t('rti.login'), to: 'https://rtionline.karnataka.gov.in/RTIMIS/login/' },
        { name: t('rti.manualStatistics'), to: 'https://ceg.karnataka.gov.in/assets/front/pdf/rti%20manual/RTI%20Manual%20English.pdf', target: '_blank' },
        // { name: t('rti.statistics'), to: 'https://ceg.karnataka.gov.in/assets/front/pdf/rti%20manual/RTI%20Manual%20English.pdf' , target: '_blank'}
      ]
    }
  ];

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [submenuPath, setSubmenuPath] = useState([]);
  const menuItemRefs = useRef({});
  const [menuMouseIn, setMenuMouseIn] = useState(false);
  const NAVBAR_HEIGHT = 150;
  const [anchorElLang, setAnchorElLang] = useState(null);
  const [selectedLang, setSelectedLang] = useState(i18n.language || 'en');
  const drawerPaperRef = useRef(null);

  const handleLangClick = (event) => setAnchorElLang(event.currentTarget);
  const handleLangClose = (lang) => {
    if (lang) {
      setSelectedLang(lang);
      i18n.changeLanguage(lang);
    }
    setAnchorElLang(null);
    setDrawerOpen(false);
  };

  const handleDesktopSubmenuOpen = (event, path) => {
    menuItemRefs.current[path.join('__')] = event.currentTarget;
    setSubmenuPath(path);
  };

  const handleDesktopSubmenuClose = () => {
    setMenuMouseIn(false);
    setSubmenuPath([]);
  };

  // Navigate to profile page
  const handleProfileClick = () => {
    navigate('/profile');
  };

  const toggleSubmenu = (name) => {
    setOpenSubmenus(prev => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  const findSubmenuByPath = (items, path) => {
    if (!path.length) return items;
    const [head, ...tail] = path;
    const found = items.find(item => item.name === head);
    if (found && found.submenu && tail.length) {
      return findSubmenuByPath(found.submenu, tail);
    }
    return found && found.submenu ? found.submenu : [];
  };

  // --- Desktop menu rendering ---
  const renderDesktopMenuItems = () => {
    return menuItems.map((item, index) => {
      const hasSubmenu = item.submenu && item.submenu.length > 0;
      const path = [item.name];

      if (hasSubmenu) {
        return (
          <Box key={`desktop-${index}`} sx={{ position: 'relative' }}>
            <Button
              size="medium"
              variant="text"
              sx={{
                textTransform: 'none',
                color: 'white',
                fontSize: { xs: '0.75rem', sm: '0.85rem', md: '0.90rem' },
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 600,
                letterSpacing: '0.5px',
                whiteSpace: 'nowrap',
                minWidth: 'auto',
                height: '40px',
                lineHeight: 1.2,
                marginLeft: "0px",
                px: 1.5,
                overflow: 'hidden',
                backgroundColor: "transparent",
                borderRadius: '4px',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { 
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                }
              }}
              ref={el => { if (el) menuItemRefs.current[path.join('__')] = el; }}
              onMouseEnter={e => handleDesktopSubmenuOpen(e, path)}
              onClick={e => {
                if (submenuPath[0] === item.name) {
                  handleDesktopSubmenuClose();
                } else {
                  handleDesktopSubmenuOpen(e, path);
                }
              }}
              endIcon={<ExpandMore fontSize="small" sx={{ transition: 'transform 0.3s ease' }} />}
            >
              {item.name}
            </Button>
          </Box>
        );
      } else {
        return (
          <Button
            key={`desktop-${index}`}
            component={Link}
            to={item.to}
            size="medium"
            variant="text"
            sx={{
              textTransform: 'none',
              color: 'white',
              fontSize: {xs: '0.75rem', sm: '0.85rem', md: '0.90rem' },
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              fontWeight: 600,
              letterSpacing: '0.5px',
              whiteSpace: 'nowrap',
              minWidth: 'auto',
              height: '40px',
              lineHeight: 1.2,
              marginLeft: "0px",
              px: 1.5,
              overflow: 'hidden',
              backgroundColor: "transparent",
              borderRadius: '4px',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': { 
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
              }
            }}
            onClick={handleDesktopSubmenuClose}
          >
            {item.name}
          </Button>
        );
      }
    });
  };

  // --- Desktop submenu poppers recursive ---
  const renderDesktopSubmenuPoppers = (items, path = [], level = 0) => {
    if (submenuPath.length <= level) return null;
    const currentPath = submenuPath.slice(0, level + 1);
    const currentAnchor = menuItemRefs.current[currentPath.join('__')];
    const submenuItems = findSubmenuByPath(menuItems, currentPath);

    if (!submenuItems || !submenuItems.length) return null;

    return (
      <Popper
        key={`popper-${level}`}
        open={submenuPath.length > level}
        anchorEl={currentAnchor}
        placement={level === 0 ? "bottom-start" : "right-start"}
        transition
        disablePortal={false}
        sx={{ zIndex: 1500 }}
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: level === 0 ? [0, 8] : [8, 0],
            },
          },
        ]}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} timeout={200}>
            <Paper
              elevation={8}
              sx={{
                minWidth: '220px',
                backgroundColor: 'white',
                borderRadius: '8px',
                overflow: 'hidden',
                border: '1px solid #e0e0e0',
                mt: level === 0 ? 0.5 : 0,
                ml: level > 0 ? 0.5 : 0,
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
              }}
              onMouseEnter={() => setMenuMouseIn(true)}
              onMouseLeave={handleDesktopSubmenuClose}
            >
              {submenuItems.map((item, idx) => {
                const hasSubmenu = item.submenu && item.submenu.length > 0;
                const nextPath = currentPath.concat(item.name);

                return (
                  <MenuItem
                    key={`submenu-${level}-${idx}`}
                    ref={el => { if (el) menuItemRefs.current[nextPath.join('__')] = el; }}
                    sx={{
                      minHeight: '44px',
                      backgroundColor: 'transparent',
                      transition: 'all 0.2s ease-in-out',
                      borderBottom: '1px solid #f0f0f0',
                      '&:last-child': { borderBottom: 'none' },
                      '&:hover': { 
                        backgroundColor: 'rgba(65, 105, 225, 0.08)',
                        transform: 'translateX(2px)'
                      }
                    }}
                    onMouseEnter={e => hasSubmenu && handleDesktopSubmenuOpen(e, nextPath)}
                    onClick={() => {
                      if (!hasSubmenu) {
                        handleDesktopSubmenuClose();
                      }
                    }}
                  >
                    {item.to ? (
                      <Link
                        to={item.to}
                        style={{
                          textDecoration: 'none',
                          color: 'inherit',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                          fontSize: '0.875rem',
                          fontWeight: 500
                        }}
                        onClick={handleDesktopSubmenuClose}
                      >
                        {item.name}
                        {hasSubmenu && <ChevronRight fontSize="small" sx={{ color: '#666' }} />}
                      </Link>
                    ) : (
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          cursor: hasSubmenu ? 'pointer' : 'default',
                          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                          fontSize: '0.875rem',
                          fontWeight: 500
                        }}
                        onClick={e => {
                          if (hasSubmenu) {
                            handleDesktopSubmenuOpen(e, nextPath);
                          }
                        }}
                      >
                        {item.name}
                        {hasSubmenu && <ChevronRight fontSize="small" sx={{ color: '#666' }} />}
                      </Box>
                    )}
                    {hasSubmenu && submenuPath[level + 1] === item.name &&
                      renderDesktopSubmenuPoppers(item.submenu, nextPath, level + 1)
                    }
                  </MenuItem>
                );
              })}
            </Paper>
          </Grow>
        )}
      </Popper>
    );
  };

  // --- Mobile menu rendering ---
  const renderNestedMenuItems = (items, level = 0) => {
    return items.map((item, index) => {
      const hasSubmenu = item.submenu && item.submenu.length > 0;
      const isOpen = openSubmenus[item.name];

      return (
        <React.Fragment key={`${level}-${index}`}>
          <ListItem
            disablePadding
            sx={{
              pl: 2 + (level * 2),
              backgroundColor: level % 2 === 0 ? 'rgba(0,0,0,0.03)' : 'inherit',
              transition: 'background-color 0.2s ease'
            }}
          >
            <ListItemButton
              component={item.to ? Link : 'div'}
              to={item.to}
              onClick={() => {
                if (!hasSubmenu && item.to) {
                  setDrawerOpen(false);
                } else if (hasSubmenu) {
                  toggleSubmenu(item.name);
                }
              }}
              sx={{
                height: '48px',
                whiteSpace: 'nowrap',
                transition: 'all 0.2s ease',
                '&:hover': { 
                  backgroundColor: 'rgba(65, 105, 225, 0.1)',
                  transform: 'translateX(4px)'
                }
              }}
            >
              <ListItemText 
                primary={item.name} 
                primaryTypographyProps={{
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  fontSize: '0.9rem',
                  fontWeight: level === 0 ? 600 : 400
                }}
              />
              {hasSubmenu && (
                <Box sx={{ transition: 'transform 0.3s ease', transform: isOpen ? 'rotate(180deg)' : 'none' }}>
                  {isOpen ? <ExpandLess /> : <ExpandMore />}
                </Box>
              )}
            </ListItemButton>
          </ListItem>
          {hasSubmenu && (
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
              {renderNestedMenuItems(item.submenu, level + 1)}
            </Collapse>
          )}
        </React.Fragment>
      );
    });
  };

  return (
    <Box sx={{
      top: 0, left: 0, width: '100%', zIndex: 1300,
      backgroundColor: 'rgb(240, 245, 248)', height: NAVBAR_HEIGHT, boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    }}>
      {/* Top Section with Logo and Text */}
      {/* <Box sx={{
        height: NAVBAR_HEIGHT, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', color: 'white',
        textAlign: 'center', px: 2, fontWeight: 'bold', fontFamily: 'Arial, sans-serif',
        userSelect: 'none', borderBottom: '1px solid rgba(255,255,255,0.3)', mb: 0,
        background: 'linear-gradient(135deg, #f1ddfaff 0%, #eedbd0ff 100%)'
      }}>
        <Box component="img" src={logo} alt="Logo"
          sx={{ 
            height: { xs: 40, sm: 45, md: 50 }, 
            mt: 5, mb: 0.5,
            transition: 'transform 0.3s ease',
            '&:hover': { transform: 'scale(1.05)' }
          }} />
      

        <Typography variant="h5" sx={{
            lineHeight: 1.1, 
            background: 'linear-gradient(135deg, #1a237e 0%, #283593 50%, #303f9f 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 700,
            textShadow: '0 2px 4px rgba(0,0,0,0.1)',
            letterSpacing: '0.5px',
            animation: 'gradientShift 3s ease-in-out infinite alternate',
            '@keyframes gradientShift': {
              '0%': {
                background: 'linear-gradient(135deg, #1a237e 0%, #283593 50%, #303f9f 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
              },
              '100%': {
                background: 'linear-gradient(135deg, #283593 0%, #303f9f 50%, #3949ab 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
              }
            }
          }}>{t('specialOfficer')}</Typography>

          <Typography variant="h6" sx={{
            lineHeight: 1.1, 
            color: '#283593',
            fontSize: { xs: '0.85rem', sm: '1rem', md: '1.25rem' },
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
            letterSpacing: '0.3px',
            animation: 'fadeInUp 1s ease-out',
            '@keyframes fadeInUp': {
              '0%': {
                opacity: 0,
                transform: 'translateY(10px)'
              },
              '100%': {
                opacity: 1,
                transform: 'translateY(0)'
              }
            }
          }}>{t('subtitle')}</Typography>

          <Typography variant="caption" sx={{
            mt: 0.3, 
            mb: 5, 
            color: '#3949ab',
            fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.9rem' },
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 500,
            letterSpacing: '0.2px',
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: '-2px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '0%',
              height: '1px',
              background: 'linear-gradient(90deg, transparent, #3949ab, transparent)',
              animation: 'underlineGrow 2s ease-in-out infinite',
            },
            '@keyframes underlineGrow': {
              '0%, 100%': {
                width: '0%'
              },
              '50%': {
                width: '80%'
              }
            }
          }}>{t('govt')}</Typography>
      </Box> */}

      {/* top nav */}
<Box sx={{
  height: NAVBAR_HEIGHT,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: { xs: 1, sm: 2, md: 3 },
  color: 'white',
  textAlign: 'center',
  userSelect: 'none',
  borderBottom: '1px solid rgba(255,255,255,0.3)',
  background: 'linear-gradient(135deg, #f1ddfaff 0%, #eedbd0ff 100%)'
}}>

  {/* Left Image - Language specific */}
  <Box component="img" 
       src={images.leftImage} 
       alt="Left Icon"
       sx={{ 
         height: { xs: 0, sm: 0, md: 85 }, 
         width: 'auto',
         transition: 'transform 0.3s ease',
         '&:hover': { transform: 'scale(1.1)' }
       }} 
  />

  {/* Center Content */}
  <Box sx={{ 
    display: 'flex', 
    flexDirection: 'column',
    alignItems: 'center', 
    justifyContent: 'center',
    flex: 1,
    gap: 0.5
  }}>
    <Box component="img" 
         src={logo} 
         alt="Logo"
         sx={{ 
           height: { xs: 40, sm: 45, md: 50 }, 
           mb: 0.5,
           transition: 'transform 0.3s ease',
           '&:hover': { transform: 'scale(1.05)' }
         }} 
    />

    <Typography variant="h5" sx={{
      lineHeight: 1.1, 
      background: 'linear-gradient(135deg, #1a237e 0%, #283593 50%, #303f9f 100%)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 700,
      textShadow: '0 2px 4px rgba(0,0,0,0.1)',
      letterSpacing: '0.5px',
      animation: 'gradientShift 3s ease-in-out infinite alternate',
      '@keyframes gradientShift': {
        '0%': {
          background: 'linear-gradient(135deg, #1a237e 0%, #283593 50%, #303f9f 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
        },
        '100%': {
          background: 'linear-gradient(135deg, #283593 0%, #303f9f 50%, #3949ab 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
        }
      }
    }}>
      {t('specialOfficer')}
    </Typography>

    <Typography variant="h6" sx={{
      lineHeight: 1.1, 
      color: '#283593',
      fontSize: { xs: '0.85rem', sm: '1rem', md: '1.25rem' },
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600,
      textShadow: '0 1px 2px rgba(0,0,0,0.1)',
      letterSpacing: '0.3px',
      animation: 'fadeInUp 1s ease-out',
      '@keyframes fadeInUp': {
        '0%': {
          opacity: 0,
          transform: 'translateY(10px)'
        },
        '100%': {
          opacity: 1,
          transform: 'translateY(0)'
        }
      }
    }}>
      {t('subtitle')}
    </Typography>

    <Typography variant="caption" sx={{
      mt: 0.3, 
      color: '#3949ab',
      fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.9rem' },
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 500,
      letterSpacing: '0.2px',
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '-2px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '0%',
        height: '1px',
        background: 'linear-gradient(90deg, transparent, #3949ab, transparent)',
        animation: 'underlineGrow 2s ease-in-out infinite',
      },
      '@keyframes underlineGrow': {
        '0%, 100%': {
          width: '0%'
        },
        '50%': {
          width: '80%'
        }
      }
    }}>
      {t('govt')}
    </Typography>
  </Box>

  {/* Right Image - Language specific */}
  <Box component="img" 
       src={images.rightImage} 
       alt="Right Icon"
       sx={{ 
         height: { xs: 0, sm: 0, md: 85 }, 
         width: 'auto',
         transition: 'transform 0.3s ease',
         '&:hover': { transform: 'scale(1.1)' }
       }} 
  />

</Box>


      {/* Bottom Section: Navigation Bar */}
      <Box sx={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: 50, paddingLeft: 2, 
        background: 'linear-gradient(135deg, #449ccbff 0%, #1a4bedff 100%)',
        mt: 0, mb: 6.5,
        boxShadow: '0 4px 12px rgba(65, 105, 225, 0.3)'
      }}>
        {/* Left: Navigation Buttons (md and above) */}
        <Box sx={{
          flex: 1, display: { xs: 'none', md: 'flex' },
          justifyContent: 'flex-start', gap: 0.5,
        }}>
          {renderDesktopMenuItems()}
        </Box>

        {/* Desktop Submenu Poppers */}
        {renderDesktopSubmenuPoppers(menuItems)}

        

        {/* Right: Language Selector & Login/Profile (md and above) */}
        <Box sx={{
          flex: 1, display: { xs: 'none', md: 'flex' },
          justifyContent: 'flex-end', alignItems: 'center', marginRight: '20px', gap: 1,
        }}>

          <MainSearchBar />
          {/* Language Selector Button */}
          <Button
            startIcon={<TranslateIcon />}
            onClick={handleLangClick}
            variant="outlined"
            size="medium"
            sx={{ 
              textTransform: 'none', 
              height: '40px', 
              minWidth: 'auto', 
              whiteSpace: 'nowrap', 
              color: 'white', 
              borderColor: 'rgba(255,255,255,0.5)',
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              fontWeight: 500,
              transition: 'all 0.3s ease',
              '&:hover': {
                borderColor: 'white',
                backgroundColor: 'rgba(255,255,255,0.1)',
                transform: 'translateY(-1px)'
              }
            }}
          >
            {languages.find((l) => l.code === selectedLang)?.label || 'Language'}
          </Button>
          <Menu
            anchorEl={anchorElLang}
            open={Boolean(anchorElLang)}
            onClose={() => handleLangClose(null)}
            TransitionComponent={Grow}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            {languages.map(({ code, label }) => (
              <MenuItem
                key={code}
                selected={code === selectedLang}
                onClick={() => handleLangClose(code)}
                sx={{
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  transition: 'all 0.2s ease',
                  '&:hover': { backgroundColor: 'rgba(65, 105, 225, 0.1)' }
                }}
              >
                {label}
              </MenuItem>
            ))}
          </Menu>
          {loading ? null : !isAuthenticated ? (
            <Button
              size="medium"
              variant="contained"
              component={Link}
              to="/accounts"
              sx={{ 
                height: '40px', 
                minWidth: 'auto', 
                whiteSpace: 'nowrap',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 600,
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                color: '#4169E1',
                transition: 'all 0.3s ease',
                '&:hover': {
                  background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(255,255,255,0.3)'
                }
              }}
              onClick={handleDesktopSubmenuClose}
            >
              {t('login')}
            </Button>
          ) : (
            <IconButton 
              color="inherit" 
              onClick={handleProfileClick} 
              sx={{ 
                ml: 1,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.1)',
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }
              }}
            >
              <AccountCircleIcon fontSize="large" />
            </IconButton>
          )}
        </Box>
        {/* Hamburger/Close Menu (md and below) */}
        <Box sx={{
          flex: 1, display: { xs: 'flex', md: 'none' },
          justifyContent: 'flex-end', alignItems: 'center', paddingRight: 2,
        }}>
          <IconButton
            color="inherit"
            aria-label={drawerOpen ? 'close drawer' : 'open drawer'}
            onClick={() => setDrawerOpen(!drawerOpen)}
            sx={{
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'scale(1.1)',
                backgroundColor: 'rgba(255,255,255,0.1)'
              }
            }}
          >
            {drawerOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        </Box>
      </Box>

      {/* Drawer for mobile/tablet */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          ref: drawerPaperRef,
          sx: {
            width: 280,
            top: `${NAVBAR_HEIGHT}px`,
            height: `calc(100% - ${NAVBAR_HEIGHT}px)`,
            display: 'flex',
            flexDirection: 'column',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
          },
        }}
        transitionDuration={300}
      >
        <Box sx={{
          position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1500,
          display: 'flex', justifyContent: 'flex-end', p: 1,
          background: 'linear-gradient(135deg, #4169E1 0%, #3a5dcc 100%)',
          color: 'white'
        }}>
          {/* <MainSearchBar /> */}
          <IconButton 
            onClick={() => setDrawerOpen(false)}
            sx={{ color: 'white' }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <List sx={{ flexGrow: 1 }}>
          {renderNestedMenuItems(menuItems)}
        </List>
        <Divider />
        {/* Language selector and login/profile for mobile */}
        <Box sx={{ p: 2, mt: 'auto', background: 'white' }}>
          <Button
            startIcon={<TranslateIcon />}
            onClick={handleLangClick}
            variant="outlined"
            size="medium"
            sx={{ 
              textTransform: 'none', 
              width: '100%',
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              fontWeight: 500,
              mb: 2
            }}
          >
            {languages.find((l) => l.code === selectedLang)?.label || 'Language'}
          </Button>
          <Menu
            anchorEl={anchorElLang}
            open={Boolean(anchorElLang)}
            onClose={() => handleLangClose(null)}
          >
            {languages.map(({ code, label }) => (
              <MenuItem
                key={code}
                selected={code === selectedLang}
                onClick={() => handleLangClose(code)}
                sx={{ fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }}
              >
                {label}
              </MenuItem>
            ))}
          </Menu>
          {loading ? null : !isAuthenticated ? (
            <Button
              size="medium"
              variant="contained"
              component={Link}
              to="/accounts"
              sx={{ 
                mt: 1, 
                width: '100%',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 600,
                background: 'linear-gradient(135deg, #4169E1 0%, #3a5dcc 100%)'
              }}
              onClick={() => setDrawerOpen(false)}
            >
              {t('login')}
            </Button>
          ) : (
            <IconButton 
              color="inherit" 
              onClick={handleProfileClick} 
              sx={{ 
                width: '100%',
                mt: 1,
                color: '#4169E1'
              }}
            >
              <AccountCircleIcon fontSize="large" />
              <Typography sx={{ ml: 1, fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }}>
                Profile
              </Typography>
            </IconButton>
          )}
        </Box>
      </Drawer>
    </Box>
  );
};